var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('iframe',{staticStyle:{"width":"100%","height":"3000px","border":"none"},attrs:{"src":"https://noisplus.it/tutorial/"}})])}
var staticRenderFns = []

export { render, staticRenderFns }